module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_2318987.1ad91ca5.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/img_on_amazon/FormatoSimplificado_2318987.pdf
// module id = 850
// module chunks = 0